import Button from './Button';
import ButtonGroup from './ButtonGroup';

const { SIZE, STYLE } = Button;
/**
 * @deprecated Use the mezzanine component '@zocdoc-mezzanine/components-button
 */
const VARIATION = STYLE;

export { Button as default, Button, ButtonGroup, SIZE, STYLE, VARIATION };
